export default function valueOrDash(value) {
  return value || value === 0 ? value : "-";
}
